<template>
  <div>
    <div class="contents">
      <article class="article-header row g-0">
        <div class="col-12">
          <h5>{{ resourcesview.title }}</h5>
        </div>
        <div class="d-flex flex-column flex-sm-row">
          <div class="d-flex align-items-center">
            <span class="icon badge bg-blue" v-if="resourcesview.type == 1">
              {{ resourcesview.type | category }}
            </span>
            <span class="icon badge bg-purple" v-if="resourcesview.type == 2">
              {{ resourcesview.type | category }}
            </span>
            <span class="icon badge bg-pink" v-if="resourcesview.type == 3">
              {{ resourcesview.type | category }}
            </span>
            <span class="icon badge bg-cyan" v-if="resourcesview.type == 4">
              {{ resourcesview.type | category }}
            </span>
            <span class="text-capitalize text-black">{{
              resourcesview.regname
            }}</span>
          </div>
          <div class="ms-sm-auto mt-2 mt-sm-0 pt-1 pt-sm-0">
            <span class="me-2 text-date">
              <i class="material-icons">date_range </i>
              {{ resourcesview.timezone_date | dateformat }}
            </span>
            <span>
              <i class="material-icons">visibility</i>
              {{ resourcesview.cnt | comma }}
            </span>
          </div>
        </div>
      </article>

      <article class="article-attach" v-if="resourcesview.filename">
        <a :href="resourcesview.download_link" class="text-truncate more">
          <i class="material-icons-outlined">file_download</i>
          <span>{{ resourcesview.originname }}</span>
        </a>
      </article>

      <article class="article-body">
        <span v-html="resourcesview.contents"></span>
      </article>

      <article class="article-footer">
        <div class="prev" :class="!next_post.resources_pk && 'no-data'">
          <router-link
            :to="{
              name: 'ResourcesView',
              params: { resourcesno: next_post.resources_pk },
            }"
            v-if="next_post.resources_pk"
          >
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ next_post.title }}</span>
          </router-link>

          <a @click="_alert($t('text.support.no_prev'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_less </i>
            <span>{{ $t("text.support.no_prev") }}</span>
          </a>
        </div>
        <div class="next" :class="!prev_post.resources_pk && 'no-data'">
          <router-link
            :to="{
              name: 'ResourcesView',
              params: { resourcesno: prev_post.resources_pk },
            }"
            v-if="prev_post.resources_pk"
          >
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ prev_post.title }}</span>
          </router-link>
          <a @click="_alert($t('text.support.no_next'))" v-else class="pointer">
            <i class="material-icons-outlined"> expand_more </i>
            <span>{{ $t("text.support.no_next") }}</span>
          </a>
        </div>
      </article>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-secondary"
          :aria-label="$t('button.common.list')"
          @click="
            $router.push({
              name: 'ResourcesList',
              query: {
                searchname: $route.query.searchname,
                searchtype: $route.query.searchtype,
              },
            })
          "
          >{{ $t("button.common.list") }}</b-button
        >
        <b-button
          size="xl"
          variant="secondary"
          :aria-label="$t('button.common.delete')"
          @click="noticeDelete"
          >{{ $t("button.common.delete") }}</b-button
        >
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.edit')"
          @click="
            $router.push({
              name: 'ResourcesWrite',
              params: { resourcesno: $route.params.resourcesno },
            })
          "
          >{{ $t("button.common.edit") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/support";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "ResourcesView",
  data() {
    return {
      param: {
        searchtype: this.$route.query.searchtype || 1,
        searchname: this.$route.query.searchname || "",
      },
      resourcesview: {
        cnt: null,
        contents: null,
        date: null,
        filename: null,
        nextno: null,
        nexttitle: null,
        path: null,
        prevno: null,
        prevtitle: null,
        status: null,
        title: null,
        topstatus: null,
        type: null,
        writer: null,
      },
      next_post: {},
      prev_post: {},
      resourcesno: this.$route.params.resourcesno || "",
    };
  },
  methods: {
    getView() {
      if (this.resourcesno) {
        ax.getResourcesView(this.resourcesno, this.param, (flag, data) => {
          if (flag) {
            this.resourcesview = data.resourcesview;
            this.next_post = data.next_post;
            this.prev_post = data.prev_post;
          } else {
            alert(data);
          }
        });
      }
    },
    noticeDelete() {
      ax.getResourcesDelete(this.resourcesno, (flag, data) => {
        if (flag) {
          alert(data.message);
          // this.$notify({
          //   group: "alert",
          //   type: "success",
          //   text: data.message,
          //   speed: 1000,
          // });
          this.$router.push({
            name: "ResourcesList",
          });
        } else {
          alert(data.message);
        }
      });
    },
    getDownload(filePath) {
      ax.getDownload(filePath, (data) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "aaa"); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
  },
  created() {
    this.getView();
  },
  watch: {
    "$route.params": function () {
      this.resourcesno = parseInt(this.$route.params.resourcesno);
      this.getView();
    },
  },
  mixins: [myMixin],
};
</script>
